import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {
    XMLHttpRequestHandler,
    XMLHttpRequestHandler_requestType
} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {quizzesView_template} from "../components/templates/quizzesView_template";
import {header} from "./header";

declare var page: any;

export class quizzes_view extends vnModule_knockoutJS {
    protected XHRHdl: XMLHttpRequestHandler;
    protected quizzesView: quizzesView_template;

    protected getModuleName() {
        return "quizzes_view";
    }

    buildContent(): Array<Element> {
        this.quizzesView = new quizzesView_template("editForm", this.viewModel, this);

        let zoneHeader = this.getVnAppZone().app.getZoneByName("Header");
        let loadedModule = zoneHeader.loadedModule;
        (<header>loadedModule).setHeaderTitle("View Quiz");

        return [this.quizzesView.build()];
    }

    public getBrandId() {
        return this.getVnAppZone().app.params.idBrand;
    }

    public getQuizId() {
        return this.getVnAppZone().app.params.id || 0;
    }

    public fillPage(): void {
        let brandId = this.getBrandId();
        this.quizzesView.setBrandId(brandId);

        this.getReferences();
    }

    protected getMemoryViewModel() {
        return this.quizzesView.getTemplateViewModel();
    }

    protected getReferences(): void {
        if (this.XHRHdl) {
            this.XHRHdl.cancelAndReset();
        }
        this.loadingIn(this.quizzesView.builtTemplate);

        let usrReq_url: string = `/api/brand/${this.getBrandId()}/quizzes/references/`;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onReferencesRequestReturn;
        this.XHRHdl.execute();
    }

    protected onReferencesRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.setReferences(responseParsed);
                obj.getData();
            });
        };
    }

    protected getData(): void {
        let id: number = 0;
        let pathId = this.getVnAppZone().app.params.id;
        if (pathId !== undefined && !isNaN(pathId)) {
            this.quizzesView.setId(pathId);
            id = pathId;
        }

        let brandId = this.getBrandId();
        let usrReq_url: string = `/api/brand/${brandId}/quizzes/get/${id}/`;
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onGetRequestReturn;
        this.XHRHdl.execute();
    }

    protected onGetRequestReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                let responseParsed = JSON.parse(req.request.response);
                obj.updateList(responseParsed.data);
                obj.loadingOut(obj.quizzesView.builtTemplate);
            });
        };
    }

    protected updateList(data): void {
        this.quizzesView.setQuiz(data);
        this.quizzesView.setBrandResults(data.stats || {}, data.brands || []);
    }

    protected setReferences(references): void {
        this.quizzesView.setBrandReferences(references.brands);
    }

    protected edit(id, brandId): void {
        page.redirect(`/brand/${brandId}/categorization/quizzes/edit/${id}`);
    }

    protected cancel(id, brandId): void {
        this.releaseLock(id, brandId);
        page.redirect(`/brand/${brandId}/categorization/quizzes/`);
    }

    protected releaseLock(id, brandId): void {
        let usrReq_url: string = `/api/brand/${brandId}/quizzes/release/${id}/`;
        let usrReq_params: Array<Array<string>> = [];

        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.mode = XMLHttpRequestHandler_requestType.POST;
        this.XHRHdl.execute();
    }

    public filterDropdownOnChange(idElement): void {
        this.quizzesView.handleBrandChange(idElement);
    }
}



// WEBPACK FOOTER //
// ./js/modules/quizzes_view.ts